import * as React from "react";
function SvgIcChevronRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 18.713l3.85-6.669L10 5.375 10.649 5l4.067 7.044-4.067 7.044-.649-.375z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronRight;
